import { ClientSettings, SelectedMediaDevices, WebClientUISettingsContext } from "@dvrt/web-phone-client";
import * as React from "react";
import { useState } from "react";
import { conferenceLocalStorage } from "../../../tools";

class WebClientUISettingsManager {
    private readonly settings: ClientSettings;
    private readonly setSettings: (s: ClientSettings) => void;
    private readonly origSettings: ClientSettings;
    public readonly phoneDialogPosition: { x: number; y: number } | null = null;

    // the origSettings is a localStorage
    constructor(settings: ClientSettings) {
        this.origSettings = settings;
        [this.settings, this.setSettings] = useState(settings);
    }

    get selectedMediaDevices() {
        return this.settings.selectedMediaDevices;
    }

    set selectedMediaDevices(selectedMediaDevices: SelectedMediaDevices) {
        this.origSettings.selectedMediaDevices = selectedMediaDevices;
        this.setSettings({
            ...this.settings,
            selectedMediaDevices,
        });
    }
}

export const WebClientUISettings = ({ children }: { children: React.ReactNode }) => {
    const mgr = new WebClientUISettingsManager(conferenceLocalStorage);
    return <WebClientUISettingsContext.Provider value={mgr}>{children}</WebClientUISettingsContext.Provider>;
};
